import { syncLocalFieldNames } from "../../constants/syncLocalFields";

/**
 * Ulysses tags properties by the field name instead of by an iD
 * @param {Map} propertiesById
 * @param {string} fieldId
 */
const getFieldNameForId = (propertiesById, referencesById, fieldId) => {
  if (syncLocalFieldNames[fieldId]) {
    return syncLocalFieldNames[fieldId];
  }
  const p = propertiesById.find(p => p.id === fieldId);
  if (p) {
    return p.label;
  }
  const r = referencesById.find(r => r.id === fieldId);
  return r ? r.label : null;
};

export default getFieldNameForId;
